import isEmpty from 'lodash/isEmpty';

import { 
  ZF_JSON_OBJECT_TYPE_PROPERTY, 
  ZF_JSON_OBJECT_VERSION_PROPERTY,
  ZF_JSON_IMAGE_TYPE,
  ZF_JSON_IMAGE_CROP_DATA_TYPE
} from 'const_shared.js';

export const zfImageOrLegacyCropDataToState = (image, legacyCropData, legacyImageSrc, legacyForcePng) => {
  if (!image) {
    return legacyCropDataToState(legacyCropData, legacyImageSrc, legacyForcePng);
  }

  return zfImageToState(image);
};

const legacyCropDataToState = (legacyCropData, legacyImageSrc, legacyForcePng) => {
  const defaultImage = {
    [ZF_JSON_OBJECT_TYPE_PROPERTY]: ZF_JSON_IMAGE_TYPE,
    [ZF_JSON_OBJECT_VERSION_PROPERTY]: 1,
    src: legacyCropData && legacyCropData.url,
    isUncompressed: !!legacyForcePng // possibly check the uncompressed variable here as well
  };

  var cropData = {
    originalImageSrc: legacyImageSrc
  };
  if (!isEmpty(legacyCropData)) {
    const { box } = legacyCropData;
    const { x1, x2, y1, y2 } = box;
    cropData = {
      ...cropData,
      x: x1,
      y: y1,
      width: x2 - x1,
      height: y2 - y1
    };
  }

  return {
    ...cropData,
    zfImage: defaultImage
  };
};

const DEFAULT_CROP_DATA = (zfImage) => ({
  [ZF_JSON_OBJECT_TYPE_PROPERTY]: ZF_JSON_IMAGE_CROP_DATA_TYPE,
  [ZF_JSON_OBJECT_VERSION_PROPERTY]: 1,
  originalImageSrc: zfImage.src,
  isOutOfBoundsAllowed: false
});

const zfImageToState = (zfImage) => {
  return {
    zfImage: zfImage,
    ...(zfImage.cropData || DEFAULT_CROP_DATA(zfImage))
  };
};

export const stateToZfImage = (currentState) => {
  const {
    zfImage,
    x, y,
    width, height,
    borderRadius,
    originalImageSrc,
    originalImageWidth,
    originalImageHeight,
    isOutOfBoundsAllowed
  } = currentState;

  return {
    ...zfImage,
    cropData: {
      [ZF_JSON_OBJECT_TYPE_PROPERTY]: ZF_JSON_IMAGE_CROP_DATA_TYPE,
      [ZF_JSON_OBJECT_VERSION_PROPERTY]: 1,
      borderRadius: borderRadius || 0,
      isOutOfBoundsAllowed: !!isOutOfBoundsAllowed,
      x, y,
      width, height,
      originalImageSrc,
      originalImageWidth,
      originalImageHeight
    }
  };
};

export const legacyCropDataToZfImage = ({ legacyCropData, legacyImageSrc }) => {
  const state = legacyCropDataToState(legacyCropData, legacyImageSrc, false);

  return stateToZfImage(state);
};
